import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/InfoBarMarketing/GET';

export const INFO_BAR_MARKETING_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const INFO_BAR_MARKETING_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
